import { render } from "./ModalTelaProduto.vue?vue&type=template&id=2054a97e&ts=true"
import script from "./ModalTelaProduto.vue?vue&type=script&lang=ts"
export * from "./ModalTelaProduto.vue?vue&type=script&lang=ts"

import "./ModalTelaProduto.vue?vue&type=style&index=0&id=2054a97e&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__